import { compose, withHandlers, mapProps } from 'recompose';
import { graphql } from 'react-apollo';

import { withDevice } from '~/features/App/Device';
import { NOTIFICATIONS_LIST, DELETE_NOTIFICATION } from '~/gql';

import { Notifications as NTFSC } from './Notifications';

const withNotificationsList = graphql(NOTIFICATIONS_LIST, {
  alias: 'withNotificationsList',
  props: ({ data }) => data,
});
const deleteNotificationMutation = graphql(DELETE_NOTIFICATION, {
  name: 'deleteNotification',
});

const enhance = compose(
  withNotificationsList,
  deleteNotificationMutation,
  withHandlers({
    onHideNotification: ({ deleteNotification }) => notificationId => {
      deleteNotification({
        variables: { notificationId },
        refetchQueries: [{ query: NOTIFICATIONS_LIST }],
      });
    },
  }),
  mapProps(({ notificationsList, ...rest }) => ({
    ...rest,
    notificationsList,
  })),
  withDevice,
);

export const Notifications = enhance(NTFSC);
